import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import PublicGoogleSheetsParser from 'public-google-sheets-parser'

createApp(App).use(router).mount('#app')